// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageClassHeading
{
    background-color: #006480;
    width: auto;
    height: auto;
    flex-grow: 1;
    font-family: "Open Sans";
    font-size: 50px;
    font-weight: 300;
    color: rgb(255, 255, 255);
    line-height: 1.3;
    border-radius: 0px;
    text-align: center;
}
.ManageClassesFormDiv
{
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
    padding: 2%;
    margin: 2% 10% 0 10%;
    background-color: #fcf2f2;
}
.ManageClassCreateButton,.AssignTeacherButton
{
    padding:  2% 4% 2% 4% ;
    border: 0;
    border-radius: 1vh;
    background-color: #03b4c6;
    color: white;
    font-size: 3vh;
}
.ManageClassesTable{
        width: 100%;
        height: auto;
        margin: 0;
}
.AssignTeacherButton
{
    padding:  1% 2% 1% 2% ;
    font-size: 2vh;
    margin: 1vh  0  1vh  1vh;
}
.ManageClassDeleteIcon
{
    margin:0 3vh 0 0;
    cursor:pointer;
}
.ManageClassDeleteIcon:hover{
    color: red;
}
.ManageClassDropdown
{
    padding: 1%;
    border: 1px solid rgb(217, 212, 212);
}
.ManageClassDropdown option,.ManageClassesFilter option
{
    color: gray;
}
.ManageClassesFilter
{
    display: flex;
    align-items: center;
    justify-content: center;
}
.ManageClassesFilter select
{
    padding: 1%;
    border: 1px solid rgb(217, 212, 212);
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.students-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.students-table th,
.students-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.students-table th {
  background-color: #f5f5f5;
}

.dialog-content button {
  padding: 8px 16px;
  background-color: #03b4c6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  margin-top: 10px;
}

.dialog-content button:hover {
  background-color: #028e9d;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/AdminActions/ManageClasses.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;;IAEI,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;AACA;QACQ,WAAW;QACX,YAAY;QACZ,SAAS;AACjB;AACA;;IAEI,sBAAsB;IACtB,cAAc;IACd,wBAAwB;AAC5B;AACA;;IAEI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;;IAEI,WAAW;IACX,oCAAoC;AACxC;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,WAAW;IACX,oCAAoC;AACxC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".ManageClassHeading\n{\n    background-color: #006480;\n    width: auto;\n    height: auto;\n    flex-grow: 1;\n    font-family: \"Open Sans\";\n    font-size: 50px;\n    font-weight: 300;\n    color: rgb(255, 255, 255);\n    line-height: 1.3;\n    border-radius: 0px;\n    text-align: center;\n}\n.ManageClassesFormDiv\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    height: auto;\n    padding: 2%;\n    margin: 2% 10% 0 10%;\n    background-color: #fcf2f2;\n}\n.ManageClassCreateButton,.AssignTeacherButton\n{\n    padding:  2% 4% 2% 4% ;\n    border: 0;\n    border-radius: 1vh;\n    background-color: #03b4c6;\n    color: white;\n    font-size: 3vh;\n}\n.ManageClassesTable{\n        width: 100%;\n        height: auto;\n        margin: 0;\n}\n.AssignTeacherButton\n{\n    padding:  1% 2% 1% 2% ;\n    font-size: 2vh;\n    margin: 1vh  0  1vh  1vh;\n}\n.ManageClassDeleteIcon\n{\n    margin:0 3vh 0 0;\n    cursor:pointer;\n}\n.ManageClassDeleteIcon:hover{\n    color: red;\n}\n.ManageClassDropdown\n{\n    padding: 1%;\n    border: 1px solid rgb(217, 212, 212);\n}\n.ManageClassDropdown option,.ManageClassesFilter option\n{\n    color: gray;\n}\n.ManageClassesFilter\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.ManageClassesFilter select\n{\n    padding: 1%;\n    border: 1px solid rgb(217, 212, 212);\n}\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.dialog-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  min-width: 300px;\n  max-width: 500px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.students-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 15px 0;\n}\n\n.students-table th,\n.students-table td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.students-table th {\n  background-color: #f5f5f5;\n}\n\n.dialog-content button {\n  padding: 8px 16px;\n  background-color: #03b4c6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  float: right;\n  margin-top: 10px;\n}\n\n.dialog-content button:hover {\n  background-color: #028e9d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
